import './commonAssets';

import '../audioblocks/stylesheets/audioblocks-style-custom.less';
import '../common/stylesheets/modules/collections/collection-browse.less';
import '../common/stylesheets/modules/survey/survey.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget.less';
import '../storyblocks/stylesheets/modules/home/storyblocks-home-redesign.less';

// React entry point


import AppLoader from '../react/AppLoader/AppLoader';

import SearchResultsContainer from '../react/app/Search/containers/SearchResultsContainer';
import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import AudioContainer from '../react/Audio/containers/AudioContainer';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import AudioSearchContainer from '../react/app/Search/containers/AudioSearchContainer';
import AudioSiteConstants from '../react/common/SiteConstants/AudioSiteConstants';
import GlobalPlayerContainer from '../react/GlobalPlayer/containers/GlobalPlayerContainer';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [
    {
      name: 'Search',
      path: new AudioSiteConstants().getSearchRoute() + '*',
      component: AudioSearchContainer,
    },
  ],
  auxApps: {
    ...NavApps,
    'audio-app': AudioContainer,
    'nps-modal': NPSModalLoaderContainer,
    'pop-up-container': PopUpsContainer, // FIXME: causes missing matching <div> in <section>
    'search-results-container': SearchResultsContainer,
    'react-toastify-container': ReactToastifyContainer, // FIXME: causes missing matching <div> in <section>
    'global-player': GlobalPlayerContainer,
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
